import HTTP from '../../Infra/Http'


export const createDiscountCode = async (codeData) => {
  return await HTTP.Post('/api/discounts/', codeData);
};

export const getAllDiscountCodes = async () => {
  return await HTTP.Get('/api/discounts/');
};

export const updateDiscountCode = async (id, codeData) => {
  return await HTTP.Put(`/api/discounts/${id}`, codeData);
};

export const deleteDiscountCode = async (id) => {
  return await HTTP.Delete(`/api/discounts/${id}`);
};